// extracted by mini-css-extract-plugin
module.exports = {"table-cell-content":"FeatureCell_table-cell-content__UyxiL"};